/**
 * Behavior for chart accordion slice
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccChartAccordionSLice = {
    attach(context, settings) {
      once('rmccChartAccordionSLice', '.paragraph--type--chart-accordion-slice', context).forEach((elem) => {

        let $button = $('.paragraph--title', $(elem)),
            $panel  = $('.field--type-text-long', $(elem));

        $button.attr( 'tabIndex', 0 );
        $panel.hide();

        // On click event.
        $button.on('click', (e) => {
          $(e.currentTarget).parent().toggleClass('open');
          $(e.currentTarget).next().slideToggle();
        });

        // On press of enter key event.
        $button.keyup(function(e) {
          if(e.keyCode == 13){
            $(e.currentTarget).parent().toggleClass('open');
            $(e.currentTarget).next().slideToggle();
          }
        });

      });
    }
  };
}) (Drupal, jQuery, once);
